import styles from "../landing-page-mobile-one.module.css";
import { usePaths } from "BEDROCK/paths";
import { useAnalyticsTracker } from "analytics-tracker";
import { StravaConnectButton } from "strava-acquisition/components/strava-connect-button";
import { useStravaDestination } from "strava-acquisition/hooks/use-strava-destination";
import { DEFAULT_COLLECTION_LIST_HANDLE } from "strava-acquisition/constants";
import { StravaAnalyticsEvents } from "strava-acquisition/types";

const DESTINATION_COLLECTION_ID = "9daeeac5-687b-4745-9651-ddaa1542ccf2";

export const TaglineSectionMobile = () => {
  const paths = usePaths();
  const { trackEvent } = useAnalyticsTracker();
  const { saveDestination } = useStravaDestination();

  const handleOAuthInitiated = () => {
    saveDestination(DESTINATION_COLLECTION_ID, DEFAULT_COLLECTION_LIST_HANDLE);
    trackEvent(StravaAnalyticsEvents.OAUTH_INITIATED);
  };

  return (
    <section className={styles.taglineSection}>
      <h2 className={styles.taglineTitle}>PERSONALISED WALL ART</h2>
      <p className={styles.taglineSubtitle}>
        with your GPS data from your walk,
        <br />
        run, hike, or ride
      </p>
      <StravaConnectButton
        returnTo={paths.stravaCallback}
        onConnect={handleOAuthInitiated}
        className={styles.taglineCTA}
      />
    </section>
  );
};
